// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__X6vz-","modalFooterButton":"ModalNotes_modalFooterButton__1zFwd"};